/*
 * Dark mode toggle
*/
	const appColorTheme = document.querySelector('[app-color-theme]')

	if (appColorTheme) {
		appColorTheme.addEventListener('click', e => {
			e.preventDefault();

			const transitionFade = document.querySelector('[site-reveal-color]')
			const root = document.documentElement
			const current = appColorTheme.getAttribute('app-color-theme')

			// transitionFade.classList.add('is--changing', 'is--inverse')
			transitionFade.classList.add('is--changing')

			setTimeout(() => {
				root.classList.add('disable--trasitions')
				transitionFade.classList.add('is--inverse')

				if (current == 'light') {
					root.classList.remove('light')
					root.classList.add('dark')
					appColorTheme.setAttribute('app-color-theme', 'dark')
					document.cookie = 'COLOR_THEME=dark;expires=' + new Date(Date.now() + 9999999999) + ';path=/;'
				} else {
					root.classList.remove('dark')
					root.classList.add('light')
					appColorTheme.setAttribute('app-color-theme', 'light')
					document.cookie = 'COLOR_THEME=light;expires=' + new Date(Date.now() + 9999999999) + ';path=/;'
				}
			}, 500)

			setTimeout(() => {
				transitionFade.classList.remove('is--changing')
			}, 1000)

			setTimeout(() => {
				transitionFade.classList.remove('is--inverse')
				root.classList.remove('disable--trasitions')
			}, 1100);
		})
	}


/*
* Dark mode detection toggle
*/
	const appHasColorTheme = document.cookie.includes('COLOR_THEME')
	const appHasDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

	if (!appHasColorTheme && appHasDarkMode) {
		if (appColorTheme) appColorTheme.setAttribute('app-color-theme', 'dark')
		document.documentElement.classList.remove('light')
		document.documentElement.classList.add('dark')
		document.cookie = 'COLOR_THEME=dark;expires=' + new Date(Date.now() + 9999999999) + ';path=/;'
	} else if (!appHasColorTheme && !appHasDarkMode) {
		if (appColorTheme) appColorTheme.setAttribute('app-color-theme', 'light')
		document.documentElement.classList.remove('dark')
		document.documentElement.classList.add('light')
		document.cookie = 'COLOR_THEME=light;expires=' + new Date(Date.now() + 9999999999) + ';path=/;'
	}
